import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Trust from './components/Trust';
import Services from './components/Services';
import Reasons from './components/Reasons';
import Pricing from './components/Pricing';
import Testimonial from './components/Testimonial';
import FAQ from './components/FAQ';
import Company from './components/Company';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    // Add Schema.org JSON-LD for LocalBusiness
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "行政書士ARISEリーガルオフィス",
      "description": "建設業の施工体制台帳・安全書類作成を専門にサポートする行政書士事務所",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "telephone": "+81-90-6672-0369",
      "faxNumber": "+81-6-4560-5163",
      "email": "arise@ishiki24.net",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "南堀江2-4-8-403",
        "addressLocality": "大阪市西区",
        "postalCode": "550-0015",
        "addressRegion": "大阪府",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.6738",
        "longitude": "135.4925"
      },
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "34.6738",
          "longitude": "135.4925"
        },
        "geoRadius": "50000"
      },
      "priceRange": "¥¥",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ]
    };

    // Add Schema.org JSON-LD for Service
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "施工体制台帳・安全書類作成代行",
      "provider": {
        "@type": "ProfessionalService",
        "name": "行政書士ARISEリーガルオフィス"
      },
      "areaServed": {
        "@type": "Country",
        "name": "日本"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "建設業書類作成サービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "施工体制台帳・安全書類作成代行"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "電子化サポート"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "月額サポート"
            }
          }
        ]
      }
    };

    // Add Schema.org JSON-LD for WebSite
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "行政書士ARISEリーガルオフィス",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${import.meta.env.VITE_SITE_URL || "https://example.com"}?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Trust />
      <Services />
      <Reasons />
      <Pricing />
      <Testimonial />
      <FAQ />
      <Company />
      <FinalCTA />
      <Footer />
    </div>
  );
}
